/**
 * 商品アドオンセレクター（Dawn 15.5.0 向け）
 *
 * - スニペットが描画された商品ページ（保証タグ / Office条件を満たす商品）でのみ動作します。
 * - 有料オプション（保証:180日 / Office 等）が選ばれている場合、
 *   "先にオプション → 後から商品" の順でカートへ追加します。
 *   新しく追加した商品がカート上部に来る仕様のため、結果として
 *   「商品(上) → 1つ目の選択 → 2つ目の選択」（ページ表示と同じ並び）になります。
 * - 各セレクトの選択値は <select name="properties[_...]"> として対象商品に記録されます
 *   （先頭 "_" のためカートには非表示 / 注文管理画面には記録）。
 *
 * 対応カートタイプ: ドロワー / 通知ポップアップ（Dawnの既定）
 *   ※「カートページ」タイプの場合は別途調整が必要です。
 */
(function () {
  const container = document.querySelector('[data-product-addons]');
  if (!container) return;

  const formId = container.getAttribute('data-product-form-id');
  const productForm = formId ? document.getElementById(formId) : null;
  if (!productForm) return;

  const selects = Array.prototype.slice.call(
    container.querySelectorAll('[data-addon-select]')
  );
  if (!selects.length) return;

  let bypass = false; // true のときは横取りせず、商品追加をDawnに任せる

  // 対象商品の数量（オプションも同数だけ追加）
  function currentQuantity() {
    const qtyInput =
      document.querySelector('[name="quantity"][form="' + formId + '"]') ||
      document.querySelector('.quantity__input');
    const q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return q > 0 ? q : 1;
  }

  // 選択された有料オプションをページ表示順で返す
  function selectedPaidAddons() {
    return selects
      .map(function (sel) {
        const opt = sel.options[sel.selectedIndex];
        const add = opt ? parseInt(opt.getAttribute('data-addon-add') || '0', 10) : 0;
        return {
          add: add,
          variantId: sel.getAttribute('data-addon-variant-id'),
          noteKey: sel.getAttribute('data-addon-note-key') || '_オプション',
          noteValue: opt ? opt.value : ''
        };
      })
      .filter(function (a) {
        return a.add > 0 && a.variantId && a.variantId !== '0';
      });
  }

  async function addItem(addon) {
    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    const props = {};
    props[addon.noteKey] = addon.noteValue;
    try {
      const res = await fetch(addUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript'
        },
        body: JSON.stringify({
          items: [
            { id: Number(addon.variantId), quantity: currentQuantity(), properties: props }
          ]
        })
      });
      const data = await res.json();
      if (data.status) {
        console.error('[addons] 追加できませんでした:', data.description || data.message);
      }
    } catch (e) {
      console.error('[addons] 追加中にエラーが発生しました', e);
    }
  }

  // document のキャプチャ段階で横取りし、Dawn本体（フォーム上のリスナー）より先に処理する
  document.addEventListener(
    'submit',
    function (e) {
      if (e.target !== productForm) return;

      // 2回目の送信（オプション追加後の再送信）はDawnに商品追加を任せる
      if (bypass) {
        bypass = false;
        return;
      }

      const addons = selectedPaidAddons();
      if (!addons.length) return; // 有料オプションなし → 通常どおりDawnが商品を追加

      e.preventDefault();
      e.stopImmediatePropagation();

      // ページ表示順を逆に追加 → 最後に商品を追加。
      // 新しい追加がカート上部に来るため、カートは
      // 「商品(上) → 1つ目の選択 → 2つ目の選択」の並びになる。
      const ordered = addons.slice().reverse();

      (async function () {
        for (let i = 0; i < ordered.length; i++) {
          await addItem(ordered[i]);
        }
      })().finally(function () {
        bypass = true;
        if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit();
        } else {
          productForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    },
    true // capture: 対象要素上のDawnリスナーより先に実行する
  );
})();
